import { RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SidemenuComponent } from "./sidemenu.component";
import { NgMaterialMultilevelMenuModule, MultilevelMenuService } from "ng-material-multilevel-menu";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

@NgModule({
  declarations: [SidemenuComponent],
  imports: [CommonModule, NgMaterialMultilevelMenuModule, RouterModule, MatProgressSpinnerModule ],
  exports: [SidemenuComponent],
  providers: [MultilevelMenuService],
})
export class SidemenuModule {}
